import { render, staticRenderFns } from "./FindWant.vue?vue&type=template&id=44513a5d&scoped=true"
import script from "./FindWant.vue?vue&type=script&lang=js"
export * from "./FindWant.vue?vue&type=script&lang=js"
import style0 from "./FindWant.vue?vue&type=style&index=0&id=44513a5d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44513a5d",
  null
  
)

export default component.exports